import React from 'react';
import './Terminal.css';

class Terminal extends React.Component {
  render() {
    const commands = [
      { type: "ping", command: "Ping to Google DNS", details: "Tests connectivity to Google's DNS server." },
      { type: "ping", command: "Ping to Local Machine", details: "Checks if the local machine is reachable." },
      { type: "dns", command: "DNS Lookup", details: "Finds the IP address of google.com."},
      { type: "http", command: "HTTPS Request", details: "Tests HTTPS connection to a local machine." },
      { type: "scan", command: "DNS Query Detection", details: "Scans for DNS services and versions."},
      { type: "attack", command: "Brute Force Attack", details: "Attempts to crack a password using multiple guesses." }
    ]
    const getCommandTypeStyle = (type) => {
      switch (type) {
        case "ping":
          return "command-ping";
        case "dns":
          return "command-dns";
        case "http":
          return "command-http";
        case "scan":
          return "command-scan";
        default:
          return "";
      }
    };

    return (
      <div className="terminal">
        <header>
          <div className="terminal-button button-close"></div>
          <div className="terminal-button button-minimize"></div>
          <div className="terminal-button button-zoom"></div>
          <div style={{marginLeft:'10px'}}>Various Custom Rules Tested</div>
        </header>

        <div className="terminal-output">
          {commands.map((cmd, index) => (
            <div key={index} className={`terminal-line ${getCommandTypeStyle(cmd.type)}`}>
              <span className="prompt">&gt; </span>
              <span className="command-desc">{cmd.command}</span>
              <pre className="command-details">{cmd.details}</pre>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Terminal;
